import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {GenerateOrdersButton} from "../../test-data-generator/buttons/GenerateOrdersButton.tsx";

const useTools = () => {

    const {allowedActions} = useVerifiedPermissions();

    const tools = [];

    tools.push(<FilterRecordsButton key='filter'/>);
    tools.push(<ReloadRecordsButton key='reload'/>);

    if (allowedActions.includes(rbacActions.DeleteOrder)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateOrder)) {
        tools.push(<AddRecordButton key='add'/>);
        tools.push(<GenerateOrdersButton key='generate' />);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Orders')}
            tools={useTools()}
        />
    );
};
